import type { TrajectoryPoint } from '../models';
import type { ComponentProps } from 'react';
import RouteMap from './RouteMap';

type RouteMapProps = ComponentProps<typeof RouteMap>;

interface RouteTrajectoryMapProps {
  trajectory: TrajectoryPoint[];
  visits: RouteMapProps['visits'];
  focusTarget: RouteMapProps['focusTarget'];
  onFocusTargetConsumed: () => void;
  liveDriverId?: string | null;
  liveRouteStatus?: RouteMapProps['liveRouteStatus'];
  driverName?: string;
}

const RouteTrajectoryMap = ({
  trajectory,
  visits,
  focusTarget,
  onFocusTargetConsumed,
  liveDriverId,
  liveRouteStatus,
  driverName,
}: RouteTrajectoryMapProps) => (
  <div className='relative z-0 flex flex-1 flex-col bg-white p-6 rounded-lg shadow-md min-h-[400px]'>
    <h3 className='mb-4 shrink-0 text-lg font-semibold text-gray-800'>
      Mapa de Trayectoria
    </h3>
    <div className='min-h-0 flex-1'>
      <RouteMap
        trajectory={trajectory}
        visits={visits}
        height='h-full min-h-[300px]'
        focusTarget={focusTarget}
        onFocusTargetConsumed={onFocusTargetConsumed}
        liveDriverId={liveDriverId}
        liveRouteStatus={liveRouteStatus}
        driverName={driverName}
      />
    </div>
  </div>
);

export default RouteTrajectoryMap;
